import React, {useState} from 'react';
import {Form, Icon, Input, Button, Select, Card, Breadcrumb, message, Divider, Row, Col} from 'antd';
import userService from "../services/users.service";
import Toolbar from '../commons/Toolbar';
import {withRouter} from "react-router-dom";
import './UsersCss.css';

const Option = Select.Option;

const successAddUser = () => {
    message.success('The user was successfully added');
};

const errorAddUser = () => {
    message.error('There was an error adding the user');
};

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UserDetailForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            officeData: [],
            usernameData: [],
            userFinishedTyping: false,
            usernameTyped: '',
            usernameDB: [],
            userExists: false,

        }
    }

    componentDidMount() {
        // To disabled submit button at the beginning.
        this.props.form.validateFields();
        userService.getOffices().then((data) => {
            this.setState(() => {
                return {officeData: data}
            })
        });
    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    };

    checkOnBlurUsername = (username) => {
        if (this.state.userFinishedTyping = true) {
            userService.findUsername(username).then((user) => {
                /* this.setState(() => {
                     return {usernameDB: user.username};

                 });*/
                if (username === user.username) {
                    console.log('Username already exists');
                    this.setState({userExists: true});
                }
                else {
                    console.log('It is a brand new user');
                    this.setState({userExists: false});
                }
            })
        }
    }


    checkUsername = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('username')) {
            callback('Username already exists');
        } else {
            callback();
        }
    };

    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('Passwords do not match');
        } else {
            callback();
        }
    };

    renderSelectOptions = (offices) => {
        let options = [];
        for (let o of offices) {
            options.push(<Option key={o._id}>{o.office}, {o.country}, {o.region}</Option>);

        }
        return options;
    };

    submit = () => {
        this.props.form.validateFields((error, user) => {
            console.log("user:", user);
            userService.addUser(user).then((resp) => {
                if (resp) {
                    successAddUser();
                } else {
                    errorAddUser();
                }
                console.log('resp: ', resp);
            });
        });

    };

    cancel = () => {
        this.props.form.resetFields();
    };

    render() {
        const {getFieldDecorator, getFieldsError, getFieldError, isFieldTouched} = this.props.form;

        // Only show error after a field is touched.
        const firstNameError = isFieldTouched('firstName') && getFieldError('firstName');
        const lastNameError = isFieldTouched('lastName') && getFieldError('lastName');
        let usernameError = isFieldTouched('username') && getFieldError('username');

        if (usernameError && this.state.userExists) {
            usernameError = usernameError + ', User already exists';
        }
        if (!usernameError && this.state.userExists) {
            usernameError = 'User already exists';
        }

        console.log('usernameError:', usernameError);
        const emailError = isFieldTouched('email') && getFieldError('email');
        const passwordError = isFieldTouched('password') && getFieldError('password');
        const confpasswordError = isFieldTouched('confirm') && getFieldError('confirm');
        const officeError = isFieldTouched('officeId') && getFieldError('officeId');
        const roleError = isFieldTouched('role') && getFieldError('role');
        const purviewError = isFieldTouched('purview') && getFieldError('purview');
        const statusError = isFieldTouched('status') && getFieldError('status');

        const formItemLayout = {
            labelCol: {span: 6},
            wrapperCol: {span: 14},
        };

        const toolBarItems = [
            {
                title: 'Save',
                icon: 'save',
                disabled: hasErrors(getFieldsError()) || this.state.userExists,
                htmlType: 'submit',
                onClick: () => this.submit(),
            },
            {
                title: 'Reset',
                icon: 'undo',
                htmlType: 'submit',
                onClick: () => this.cancel(),
            },
            {
                title: 'Return',
                icon: 'arrow-left',
                onClick: () => this.props.history.push({
                    pathname: '/users'
                })
            },
        ]

        return (

            <div>
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        <Breadcrumb.Item>User Detail</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <Col span={24}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>

                        </Row>
                    </Col>
                    <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                </Row>
                <Row>
                    <Card bordered={false} >
                        <Card type="inner" title="Personal Information" style={{boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)',}}>
                            <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                                <Form.Item label="First Name" validateStatus={firstNameError ? 'error' : ''}
                                           help={firstNameError || ''}>
                                    {getFieldDecorator('firstName', {
                                        rules: [{required: true, message: 'Please input your First Name!'}],
                                    })(
                                        <Input
                                            //prefix={<Icon type="firstName" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            placeholder="First Name"
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item label="Last Name" validateStatus={lastNameError ? 'error' : ''}
                                           help={lastNameError || ''}>
                                    {getFieldDecorator('lastName', {
                                        rules: [{required: true, message: 'Please input your Last Name!'}],
                                    })(
                                        <Input
                                            //prefix={<Icon type="firstName" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            placeholder="Last Name"
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item label="E-mail" validateStatus={emailError ? 'error' : ''}
                                           help={emailError || ''}>
                                    {getFieldDecorator('email', {
                                        rules: [{type: 'email', message: 'Please input a valid E-mail!'}, {
                                            required: true,
                                            message: 'Please input your E-mail!'
                                        }],
                                    })(
                                        <Input
                                            prefix={<Icon type="mail" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                            placeholder="email"
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item label="User Name" validateStatus={usernameError ? 'error' : ''}
                                           help={usernameError || ''}>
                                    {getFieldDecorator('username', {
                                        rules: [{required: true, message: 'Please input your User Name!'},

                                        ],
                                    })(
                                        <Input
                                            prefix={<Icon type="user" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                            placeholder="username" autoComplete='new-username'
                                            onBlur={(e) => {
                                                this.state.userFinishedTyping = true;
                                                this.state.usernameTyped = e.currentTarget.value;
                                                this.checkOnBlurUsername(this.state.usernameTyped);
                                            }}
                                            onChange={(e) => {
                                                console.log('usernameTyped: ', e.value);
                                            }}
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item label="Password" validateStatus={passwordError ? 'error' : ''}
                                           help={passwordError || ''}>
                                    {getFieldDecorator('password', {
                                        rules: [{
                                            required: true,
                                            message: 'Please input your password!',
                                            min: 6,
                                            message: 'Password  must be at least 6 characters'
                                        }],
                                    })(
                                        <Input
                                            prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                            type="password"
                                            placeholder="password" autoComplete='new-password'
                                        />,
                                    )}
                                </Form.Item>
                                <Form.Item label="Confirm your Password"
                                           validateStatus={confpasswordError ? 'error' : ''}
                                           help={confpasswordError || ''} hasFeedback>
                                    {getFieldDecorator('confirm', {
                                        rules: [{
                                            required: true,
                                            message: 'Please confirm your password!',
                                            min: 6,
                                            message: 'Password  must be at least 6 characters'
                                        },
                                            {validator: this.checkPassword,}],
                                    })(
                                        <Input
                                            prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                            type="password"
                                            placeholder="password"
                                        />,
                                    )}
                                </Form.Item>
                            </Form>
                        </Card>
                    </Card>
                </Row>
                <Divider/>
                <Row>
                    <Card bordered={false} type="inner" title="Status and Office Information" style={{marginTop: 16, boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)'}}>
                        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                            <Form.Item label="Office" validateStatus={officeError ? 'error' : ''}
                                       help={officeError || ''} hasFeedback>
                                {getFieldDecorator('officeId', {
                                    rules: [{required: true, message: 'Please select your Office'}],
                                })(
                                    <Select placeholder="Please select a country">
                                        {this.renderSelectOptions(this.state.officeData)}
                                    </Select>,
                                )}
                            </Form.Item>
                            <Form.Item label="Role" validateStatus={roleError ? 'error' : ''}
                                       help={roleError || ''} hasFeedback>
                                {getFieldDecorator('role', {
                                    rules: [{required: true, message: 'Please select your role'}],
                                })(
                                    <Select placeholder="Please select your role">
                                        <Option value="Data Entry">General User</Option>
                                        <Option value="Supervisor">Supervisor</Option>
                                        <Option value="Administrator">Manager</Option>
                                    </Select>,
                                )}
                            </Form.Item>
                            <Form.Item label="Purview" validateStatus={purviewError ? 'error' : ''}
                                       help={purviewError || ''} hasFeedback>
                                {getFieldDecorator('purview', {
                                    rules: [{required: true, message: 'Please select purview'}],
                                })(
                                    <Select placeholder="Please select purview">
                                        <Option value="User">Local</Option>
                                        <Option value="Office">Office</Option>
                                        <Option value="Country">Country</Option>
                                        <Option value="Region">Region</Option>
                                        <Option value="Organization">Organization</Option>
                                    </Select>,
                                )}
                            </Form.Item>
                            <Form.Item label="Status" validateStatus={statusError ? 'error' : ''}
                                       help={statusError || ''} hasFeedback>
                                {getFieldDecorator('status', {
                                    rules: [{required: true, message: 'Please select a Status'}],
                                })(
                                    <Select placeholder="Please select a status">
                                        <Option value="Active">Active</Option>
                                        <Option value="Inactive">Inactive</Option>
                                    </Select>,
                                )}
                            </Form.Item>
                        </Form>
                    </Card>
                </Row>
            </div>
        );
    }
}

const WrappedUserDetailForm = Form.create({name: 'userDetail_form'})(UserDetailForm);

export default withRouter(WrappedUserDetailForm)